var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"14","fill":"none"}},[_c('path',{attrs:{"d":"M2.29 7.71a1 1 0 010-1.42l4.59-4.58A1 1 0 105.47.3L.87 4.9a3 3 0 000 4.23l4.6 4.6a1 1 0 001.4-1.43L2.3 7.71z","fill":"#242424"}})])}
var staticRenderFns = []

export { render, staticRenderFns }